import * as React from 'react';

import { asPercent } from './helpers/asPercent';

interface TopEmotionsProps {
  joy: number;
  anger: number;
  fear: number;
  sadness: number;
  surprise: number;
  disgust: number;
  trust: number;
  anticipation: number;
}

const sortEmotions = (data: TopEmotionsProps) => {
  return Object.entries(data)
    .filter(([, value]) => value > 0) // exclude 0 values
    .sort(([, a], [, b]) => b - a); // sort descending
};

const TopEmotions: React.FC<{ data: TopEmotionsProps }> = ({ data }) => {
  if (!data) return null;
  const sortedEmotions = sortEmotions(data);

  return (
    <div>
      <h3>Top Emotions</h3>
      <div className="Stack">
        {sortedEmotions.map(([key, value]) => {
          const title = key.charAt(0).toUpperCase() + key.slice(1);
          return (
            <span key={key} style={{ display: 'flex', gap: '0.5rem' }}>
              <strong>{title}:</strong> {asPercent(value)}
            </span>
          );
        })}
      </div>
    </div>
  );
};

export default TopEmotions;
